import axiosClient from '@/api/axios-client';

import { GameType, GameId } from './types';

type GetGame = {
  type: GameType;
};

export const getGame = (gameId: GameId): Promise<GetGame> => {
  return axiosClient
    .get(`/api/games/${encodeURIComponent(gameId)}`)
    .then((res) => {
      const raw = res.data as GetGame | { data: GetGame };
      if (typeof raw === 'object' && raw && 'data' in raw && (raw as { data: GetGame }).data) {
        return (raw as { data: GetGame }).data;
      }
      return raw as GetGame;
    });
};

export const createGame = (type: GameType = 'invite'): Promise<GameId> => {
  return axiosClient.get(`/api/game/${type}`).then((res) => {
    const data = res.data as GameId | { token: string };
    if (typeof data === 'object' && data !== null && 'token' in data) {
      return (data as { token: string }).token;
    }
    return data as GameId;
  });
};
